export type Device = {
    key: string;
    name: string;
    unit: string;
    icon: string;
    // By default is bluetooth
    mode?: "usb" | "bluetooth";
};

export const DEVICE_NAMES = {
    "Temperature": "Temperature sensor",
    "PH": "PH sensor",
    "Photogate": "Photogate",
    "Voltage": "Voltage sensor",
}

export const DEVICES: Record<string, Omit<Device, 'key'>> = {
    "Temperature (Bluetooth)": { name: DEVICE_NAMES.Temperature, unit: "°C", icon: '🌡️' },
    "PH (Bluetooth)": { name: DEVICE_NAMES.PH, unit: "pH", icon: '🧪' },
    "Photogate (Bluetooth)": { name: DEVICE_NAMES.Photogate, unit: "μs", icon: '☀️' },
    "Voltage (Bluetooth)": { name: DEVICE_NAMES.Voltage, unit: "V", icon: '⚡' },
};

export const DEVICE_LIST: Device[] = Object.entries(DEVICES).map(([key, device]) => ({
    key,
    ...device,
}));